'use strict';
import Swiper from 'swiper/bundle';

/**
 * @classname Slider
 * @classdesc スライダー
 */
export default class Slider {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 */
	constructor($e, controller) {
		console.log('Slider.constructor')
		this._$e = $e
		this._$slide = $e.find('.swiper-slide');

		this.init()
		this.sliderLayoutSetting();

		$(window).on('resize', () => {
			this.sliderLayoutSetting();
		});

	}
	/**
	 * clickのコールバック
	 *
	 * @memberof Slider
	 * @return {undefined}
	 */
	init() {

		const classes = this._$e.attr('class').split(' ');
		let slidable = this._$slide.length > 7

		if (classes.indexOf('swiper-top') !== -1) {
			// トップ　イチオシ特集
			const swiper_top = new Swiper('.swiper-top', {
				loop: slidable,
				slidesPerView: 2.1,
				//speed: 3000,
				spaceBetween: 18,
				autoplay: {
					delay: 3000, // スライド間の遅延時間（ミリ秒単位）
					disableOnInteraction: false, // ユーザーの操作後に自動スクロールを再開するかどうか
				},
				breakpoints: {
					768: {
					slidesPerView: 3.2,
					//centeredSlides : true,
					spaceBetween: 36
					},
				},
				pagination: {
					el: '.swiper-pagination',
					clickable: true
				},
				navigation: {
					nextEl: '.swiper-top-button-next',
					prevEl: '.swiper-top-button-prev'
				},
			});
		} else if (classes.indexOf('swiper-recommend-jobs') !== -1) {
			// トップ　人気のリゾートバイト
			const recommend_jobs = new Swiper('.swiper-recommend-jobs', {
				loop: slidable,
				slidesPerView: 2,
				spaceBetween: 18,
				breakpoints: {
					568: {
						slidesPerView: 3,
						spaceBetween: 18
						},
					768: {
						slidesPerView: 4,
						spaceBetween: 36
					},
				},
				pagination: {
					el: '.swiper-pagination-recommend_jobs',
					clickable: true
				},
				navigation: {
					nextEl: '.swiper-button-next-recommend_jobs',
					prevEl: '.swiper-button-prev-recommend_jobs'
				},
			});
		} else if (classes.indexOf('swiper-wrapper-thumbnail') !== -1) {
			// 求人詳細メイン
			const swiper_jobthumbnail = new Swiper('.swiper-wrapper-thumbnail', {
				slidesPerView: 5,
				spaceBetween: 10,
				freeMode: true,
				watchSlidesVisibility: true,
				watchSlidesProgress: true,
			});
			const slider_jobdetail = new Swiper('.swiper-job-detail', {
				slidesPerView: 1,
				spaceBetween: 20,
				thumbs: {
				swiper: swiper_jobthumbnail
				}
			});
		} else if (classes.indexOf('swiper-wrapper-thumbnail2') !== -1) {
			// 求人詳細_寮環境
			const swiper_jobthumbnail2 = new Swiper('.swiper-wrapper-thumbnail2', {
				slidesPerView: 5,
				spaceBetween: 10,
				freeMode: true,
				watchSlidesVisibility: true,
				watchSlidesProgress: true,
			});
			const slider_jobdetail2 = new Swiper('.swiper-job-detail2', {
				slidesPerView: 1,
				spaceBetween: 20,
				thumbs: {
				swiper: swiper_jobthumbnail2
				}
			});
		} else if (classes.indexOf('swiper-viewed-jobs') !== -1) {
			// 検索詳細　最近見た求人
			const swiper_viewed_jobs = new Swiper('.swiper-viewed-jobs', {
				loop: slidable,
				slidesPerView: 2,
				spaceBetween: 18,
				breakpoints: {
					768: {
					slidesPerView: 4,
					spaceBetween: 36
					},
				},
				pagination: {
					el: '.swiper-pagination-viewed-jobs',
					clickable: true
				},
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev'
				},
			});
		} else if (classes.indexOf('swiper-viewed-experience') !== -1) {
			// 体験談詳細　その他のリゾートバイト体験談
			const swiper_viewed_experience = new Swiper('.swiper-viewed-experience', {
				loop: slidable,
				slidesPerView: 2,
				spaceBetween: 10,
				breakpoints: {
					768: {
					slidesPerView: 3,
					spaceBetween: 18,
					},
				},
				pagination: {
					el: '.swiper-pagination-viewed-experiences',
					clickable: true
				},
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev'
				},
			});
		} else if (classes.indexOf('swiper-facility-thumbnail') !== -1) {
			// 特集（エリア、施設）施設紹介
			const swiperInstances = {};
			const currentElement = this._$e;
			console.log('id;' + currentElement.attr('id'))

			console.log('特集（エリア、施設）施設紹介')
			swiperInstances[currentElement.attr('id')] = {
				swiperFacilityThumbnail: new Swiper(`#` + currentElement.attr('id'), {
					slidesPerView: 6,
					spaceBetween: 10,
					freeMode: true,
					watchSlidesVisibility: true,
					watchSlidesProgress: true,
				})
			};
			swiperInstances[currentElement.attr('id')] = {
				sliderFacility: new Swiper(`#` + currentElement.siblings('.swiper-facility').attr('id'), {
					slidesPerView: 1,
					spaceBetween: 20,
					thumbs: {
						swiper: swiperInstances[currentElement.attr('id')].swiperFacilityThumbnail
					}
				})
			};

		} else if (classes.indexOf('swiper-viewed-jobs-season') !== -1) {
			// 夏のおすすめ求人(季節)
			const swiper_viewed_jobs_season = new Swiper('.swiper-viewed-jobs-season', {
				loop: slidable,
				slidesPerView: 2.2,
				spaceBetween: 18,
				breakpoints: {
					768: {
						slidesPerView: 3.4,
						spaceBetween: 36
					},
					910: {
						slidesPerView: 4.4,
						spaceBetween: 36
					},
					1400: {
						slidesPerView: 5.4,
						spaceBetween: 36
					},
					1600: {
						slidesPerView: 6.4,
						spaceBetween: 36
					},
				},
				pagination: {
					el: '.swiper-pagination-viewed-jobs',
					clickable: true
				},
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev'
				},
			});
		} else if (classes.indexOf('swiper-begginer') !== -1) {
			// はじめての方へ　全国どこでも好きな場所で働ける
			const swiper_begginer = new Swiper('.swiper-begginer', {
				loop: true,
				slidesPerView: 1.1,
				spaceBetween: 10,
				centeredSlides : true,
				breakpoints: {
					768: {
					slidesPerView: 2,
					spaceBetween: 36,
					centeredSlides : false,
					},
				},
				pagination: {
					el: '.swiper-pagination',
					clickable: true
				},
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev'
				},
			});
		}

	}

	/**
	 * clickのコールバック
	 *
	 * @memberof Swiper
	 * @return {undefined}
	 */
	 sliderLayoutSetting() {
		// スライドの数が画面幅より少ない場合は、ページネーションを非表示にする
		const windowWidth = $(window).width();

		this._$e.each((idx, e) => {
			const $e = $(e)

			const $pagination = $e.find('.pagination-box');

			let type = ''
			let sp_max_length
			let md_max_length
			let pc_max_length
			let l_max_length
			let xl_max_length
			let xxl_max_length
		
			if($e.hasClass('swiper-viewed-experience')) {
				type = 'experience'
			}else if($e.hasClass('swiper-viewed-jobs-season')){
				type = 'season'
			}else if($e.hasClass('swiper-top')){
				type = 'top'
			}else if($e.hasClass('swiper-recommend-jobs')){
				type = 'recommend-jobs'
			}else if($e.hasClass('swiper-viewed-jobs')){
				type = 'viewed-jobs'
			}
		
			switch (type) {
				// 体験談 その他のリゾートバイト体験談
				case 'experience':
					xxl_max_length = 3
					xl_max_length = 3
					l_max_length = 3
					pc_max_length = 3
					md_max_length = 2
					sp_max_length = 2
					break;
				// おすすめ特集>〇〇のおすすめ求人
				case 'season':
					xxl_max_length = 6
					xl_max_length = 5
					l_max_length = 4
					pc_max_length = 3
					md_max_length = 2
					sp_max_length = 2
					break;
				// TOP>イチオシ特集
				case 'top':
					xxl_max_length = 3
					xl_max_length = 3
					l_max_length = 3
					pc_max_length = 3
					md_max_length = 2
					sp_max_length = 2
					break;
				// TOP>おすすめの求人
				case 'recommend-jobs':
					xxl_max_length = 4
					xl_max_length = 4
					l_max_length = 4
					pc_max_length = 4
					md_max_length = 3
					sp_max_length = 2
					break;
				// 求人詳細>最近見た求人
				case 'viewed-jobs':
					xxl_max_length = 4
					xl_max_length = 4
					l_max_length = 4
					pc_max_length = 4
					md_max_length = 2
					sp_max_length = 2
					break;
			}
		
			console.log('swiper_type::' + type)
		
			//スライドの枚数が指定より少なければページネーション非表示
			if(type !== '') {
				console.log('スライドの枚数が指定より少なければページネーション非表示')
				console.log('windowWidth::' + windowWidth)
				console.log('this._$slide.length::' + this._$slide.length)
				if(windowWidth > 1600 ){
					//1600px以上
					if (this._$slide.length <= xxl_max_length) {
						$pagination.addClass('hide');
						console.log('hideつく？')
					}else {
						$pagination.removeClass('hide');
					}
				}else if(windowWidth > 1400 ){
					//1400px以上
					if (this._$slide.length <= xl_max_length) {
						$pagination.addClass('hide');
					}else {
						$pagination.removeClass('hide');
					}
				}else if(windowWidth > 910 ){
					//910px以上
					if (this._$slide.length <= l_max_length) {
						$pagination.addClass('hide');
					}else {
						$pagination.removeClass('hide');
					}
				}else if(windowWidth > 768 ){
					//PC
					if (this._$slide.length <= pc_max_length) {
						$pagination.addClass('hide');
					}else {
						$pagination.removeClass('hide');
					}
				}else if(windowWidth > 568 ){
					//タブレット
					if (this._$slide.length <= md_max_length) {
						$pagination.addClass('hide');
					}else {
						$pagination.removeClass('hide');
					}
				}else {
					//SP
					if (this._$slide.length <= sp_max_length) {
						$pagination.addClass('hide');
					}else {
						$pagination.removeClass('hide');
					}
				}
			}

		})
	}

	/**
	 * clickのコールバック
	 *
	 * @memberof Swiper
	 * @return {undefined}
	 */
	onDisabledClick(e) {
		//e.preventDefault()
	}
}
	
